<section class="content">
  <h1>Files management</h1>
  @if (error !== '' || success !== '') {
    <mat-card class="mb-m p-m">
      @if (success !== '' ) {
        <p>
          {{ success }}
        </p>
      }
      @if (error !== '' ) {
        <p>
          {{ error }}
        </p>
      }
    </mat-card>
  }
  <div class="d-flex aic">
    <button  matIconButton (click)="addContainer()" color="accent" alt="Create Container" title="Create Container">
      <mat-icon class="material-symbols-outlined">box_add</mat-icon>
    </button><span (click)="addContainer()"> Add Container</span>
  </div>

  <div class="d-flex jcsb">
    <div class="tree w-30">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="files-tree">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
          <div class="mat-tree-node d-flex jcsb">
            <button mat-icon-button class="w-20"
                    matTreeNodeToggle
                    [attr.aria-label]="'Toggle ' + node.name"
                    (click)="selectedContainer = node.properties.container; selectedFolder = node.properties.folder; selectedNode = node">
              <mat-icon class="material-symbols-outlined">{{
                  selectedNode === node ? 'folder_open' : 'folder'
                }}
              </mat-icon>
            </button>
            <div class="w-80">{{node.name}}</div>
          </div>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
          <div class="mat-tree-node d-flex jcsb">
            <button mat-icon-button matTreeNodeToggle
                    class="w-20"
                    [attr.aria-label]="'Toggle ' + node.name"
                    (click)="selectedContainer = node.properties.container; selectedFolder = node.properties.folder;  selectedNode = node">
              <mat-icon class="material-symbols-outlined">
                {{selectedNode === node ? 'folder_open' : 'folder'}}
              </mat-icon>
            </button>
            <div class="w-80">{{node.name}}</div>
          </div>

          <!-- There is inline padding applied to this div using styles.
          This padding value depends on the mat-icon-button width.  -->
          <div [class.files-tree-invisible]="!treeControl.isExpanded(node)"
               role="group">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
        </mat-nested-tree-node>
      </mat-tree>
    </div>
    <div class="files w-70">
      <app-file-list [container]="selectedContainer" [folder]="selectedFolder" [user]="user"
                     (newFolder)="listContainers(); expandContainer()" (folderDeleted)="listContainers();listSubFolders($event.container, $event.folder)" (containerDeleted)="this.selectedContainer = null; this.selectedFolder = null;listContainers()"></app-file-list>
    </div>
  </div>

</section>
